module.exports = __webpack_public_path__ + "img/start.79dc8576.png";